export function fiItemsFlatten<T extends { ChildItems?: T[] }>(items: T[]): T[] {
    const result: T[] = [];
    const traverseFn = (currentItems: T[]) => {
        currentItems.forEach((currentItem) => {
            result.push(currentItem);
            if (currentItem.ChildItems?.length) {
                traverseFn(currentItem.ChildItems);
            }
        });
    };

    traverseFn(items);
    return result;
}

export function fiExecuteOnChildItems<T extends { ChildItems: T[] }>(item: T, executeFn: (childItem: T) => void): void {
    if (item.ChildItems) {
        item.ChildItems.forEach((childItem) => {
            executeFn(childItem);
            fiExecuteOnChildItems(childItem, executeFn);
        });
    }
}

export function fiExecuteOnItemsWithChildren<T extends { ChildItems: T[] }>(
    items: T[],
    executeFn: (childItem: T) => void,
): void {
    items.forEach((item) => {
        executeFn(item);
        fiExecuteOnChildItems(item, executeFn);
    });
}
